import { useCallback, useEffect, useState } from 'react';
import { Col, Nav, Row, Tab } from "react-bootstrap";
import { svgIcons } from '../../../../style/fonts/SvgIcons';
import '../ProjectTabs.css';
import AllProjectNotes from './AllProjectNotes';
import ClientNotes from './ClientprojectNotes';
import InternalNotes from './InternalprojectNotes';
import NoteProjectSidebar from './NotesSidebarForm/NotesProjectSidebar';
import { useGetAllProjectNotesQuery } from '../../../../services/EndPointsApis';
import { useParams } from 'react-router-dom';
import { usePermission } from '../../../../core/hooks/PermissionHook';
import { constantsPermission } from '../../../../Config/Constants';
import { debounce } from 'lodash';

const ProjectNotes = ({ projectId, projectLookups }: any) => {


    const [pageNumber, setPageNumber] = useState(1)
    const [pageSize, setPageSize] = useState(15);
    const [searchStr, setSearchStr] = useState('');
    const [sortBy, setSortBy] = useState("createDT");
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortedColumn, setSortedColumn] = useState("createDT");
    const [immediateSearchStr, setImmediateSearchStr] = useState('')

    //Get All Project Notes
    const { data: getallpNotes, refetch } = useGetAllProjectNotesQuery({
        ProjectId: projectId,
        pageNumber: pageNumber,
        pageSize: pageSize,
        searchStr: searchStr || '',
        sortBy: sortBy,
        sortOrder: sortOrder,
    });
    //search code
    const handleSearchChange = (e: any) => {
        const { value } = e.target;
        setImmediateSearchStr(value);
        delayedSearch(value);
    };

    const delayedSearch = useCallback(
        debounce((searchValue) => {
            setSearchStr(searchValue);
        }, 800),
        []
    );
    useEffect(() => {
        if (searchStr === "" ||
            sortOrder === "" ||
            sortBy === "") {
            refetch();
        }
    }, [searchStr, sortOrder, sortBy]);


    //PermssionHook
    const { view: viewNotes, edit: editNotes, create: createNotes } = usePermission(constantsPermission?.moduleId?.notes);


    const [strikeOut, setStrikeOut] = useState<string | null>(null);

    const handleStrikeOut = (id: string) => {
        setStrikeOut((prevId) => (prevId === id ? null : id));
    }
    const [activityTogglePopup, setActivityTogglePopup] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [notesId, setNotesId] = useState(false);
    const handleAddNotes = () => {
        setActivityTogglePopup(true);
        setIsEditing(false);
    };
    const handleEditNotes = (itemId: any) => {
        setNotesId(itemId)
        setActivityTogglePopup(true);
        setIsEditing(true)
    };

    const closeSidebar = () => {
        setActivityTogglePopup(false);
    };

    useEffect(() => {
        refetch()
    }, [])
    return (
        <>
            <NoteProjectSidebar
                notesId={notesId} setActivityTogglePopup={setActivityTogglePopup}
                activityTogglePopup={activityTogglePopup} closeSidebar={closeSidebar}
                isEditing={isEditing} projectLookups={projectLookups}
                refetch={refetch}
            />
            <div className='row'>
                <div className='col-md-12'>
                    <div className='card card-css'>
                        <div className='card-header'>
                            <div className='d-flex justify-content-between align-items-center'>
                                <h5>Notes</h5>
                                <div className='d-flex gap-2 align-items-center'>
                                    {createNotes &&
                                        <button className='btn btn-primary' onClick={handleAddNotes}>
                                            <i className='ti ti-plus'></i>
                                            Add Notes
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='card-body card-body-padding'>
                            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                                <Row>
                                    <Col sm={12}>
                                        <Nav variant="pills" className="flex">
                                            <Nav.Item>
                                                <Nav.Link eventKey="first">All Notes</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="third">Internal Notes</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="second">Client Notes</Nav.Link>
                                            </Nav.Item>

                                        </Nav>
                                    </Col>
                                    <Col sm={12} className='mt-3'>
                                        <Tab.Content>
                                            <Tab.Pane eventKey="first">
                                                <div className="icon-form">
                                                    <span className="form-icon">
                                                        <i className="ti ti-search" />
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search Notes"
                                                        value={immediateSearchStr}
                                                        onChange={handleSearchChange}
                                                    />
                                                </div>
                                                <AllProjectNotes getallpNotes={getallpNotes} strikeOut={strikeOut} handleStrikeOut={handleStrikeOut}
                                                    handleEditNotes={handleEditNotes} editNotes={editNotes}
                                                    setIsEditing={setIsEditing} projectLookups={projectLookups} projectId={projectId} 
                                                    pageSize={pageSize} setPageNumber={setPageNumber} setPageSize={setPageSize} />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="second">
                                                <div className="icon-form">
                                                    <span className="form-icon">
                                                        <i className="ti ti-search" />
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search Notes"
                                                    />
                                                </div>
                                                <ClientNotes getallpNotes={getallpNotes} strikeOut={strikeOut} projectLookups={projectLookups} handleStrikeOut={handleStrikeOut}
                                                    handleEditNotes={handleEditNotes} setIsEditing={setIsEditing} editNotes={editNotes} projectId={projectId} setPageNumber={setPageNumber}
                                                    pageSize={pageSize} setPageSize={setPageSize} />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="third">
                                                <div className="icon-form">
                                                    <span className="form-icon">
                                                        <i className="ti ti-search" />
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search Notes"
                                                    />
                                                </div>
                                                <InternalNotes getallpNotes={getallpNotes} strikeOut={strikeOut} projectLookups={projectLookups} handleStrikeOut={handleStrikeOut}
                                                    handleEditNotes={handleEditNotes} setIsEditing={setIsEditing} editNotes={editNotes} projectId={projectId} setPageNumber={setPageNumber}
                                                    pageSize={pageSize} setPageSize={setPageSize} />
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Col>
                                </Row>
                            </Tab.Container>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProjectNotes;
